import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
  InputSignal,
  signal,
  WritableSignal
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'sz-toggle',
  templateUrl: './sz-toggle.component.html',
  styleUrls: ['./sz-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SzToggleComponent),
      multi: true
    }
  ]
})
export class SzToggleComponent implements ControlValueAccessor {
  readonly ariaLabel: InputSignal<string | null> = input<string | null>(null);

  readonly value: WritableSignal<boolean> = signal<boolean>(false);
  readonly disabledState: WritableSignal<boolean> = signal<boolean>(false);

  private onChange: (value: boolean) => void = (): void => {};
  private onTouched: () => void = (): void => {};

  writeValue(value: boolean | null): void {
    this.value.set(value === true);
  }

  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabledState.set(isDisabled);
  }

  toggle(): void {
    if (this.disabledState()) {
      return;
    }
    const next: boolean = !this.value();
    this.value.set(next);
    this.onChange(next);
    this.onTouched();
  }
}
